module.exports = __webpack_public_path__ + "static/media/ticketHossLogo.5ea34c38.svg";